
import React from 'react';

interface CenterTextProps {
  center: { x: number; y: number };
}

export const CenterText: React.FC<CenterTextProps> = ({ center }) => (
  <>
    <circle cx={center.x} cy={center.y} r="115" fill="white"/>
    <text
      x={center.x}
      y={center.y - 8}
      textAnchor="middle"
      className="text-[22px] font-medium fill-gray-600"
    >
      Ovarian
    </text>
    <text
      x={center.x}
      y={center.y + 20}
      textAnchor="middle"
      className="text-[22px] font-medium fill-gray-600"
    >
      Cycle
    </text>
  </>
);
